import * as React from 'react';
import { Status } from './SurveysFilter';
import { createSharedStateFromHook } from '../../../hooks/createSharedStateFromHook';

const useSurveysListBase = () => {
  const [surveyCount, setSurveyCount] = React.useState(0);
  const [isCreatingSurvey, setIsCreatingSurvey] = React.useState(false);
  const [statusFilters, setStatusFilters] = React.useState<Status[]>([
    'active',
    'draft',
  ]);
  const [searchValue, setSearchValue] = React.useState<string>('*');

  return {
    surveyCount,
    setSurveyCount,
    isCreatingSurvey,
    setIsCreatingSurvey,
    statusFilters,
    setStatusFilters,
    searchValue,
    setSearchValue,
  };
};

const [useSurveysList, UseSurveysListProvider] =
  createSharedStateFromHook(useSurveysListBase);

export default useSurveysList;

export { UseSurveysListProvider };
